export const multiAreaCascadeConstants = {
  MULTI_AREA_CASCADE_INITIAL: "MULTI_AREA_CASCADE_INITIAL",
  ADD_MULTI_AREA_NEW_FIELD: "ADD_MULTI_AREA_NEW_FIELD",
  REMOVE_MULTI_AREA_FIELD: "REMOVE_MULTI_AREA_FIELD",
  CLEAR_ALL_MULTI_AREA: "CLEAR_ALL_MULTI_AREA",
  CHANGE_MULTI_AREA_FIELD: "CHANGE_MULTI_AREA_FIELD",
  LOAD_MULTI_AREA_CASCADE_FIELDS: "LOAD_MULTI_AREA_CASCADE_FIELDS"
}